export const firebaseProjectToken = '06241c1a-104e-4435-9125-5a1c66ced124';

// eslint-disable-next-line max-len
export const firebaseVapidKey = 'BGR4ZyzoJbyBPNc_ZAd9C0aBrAa34n2kbo2pVKQmZv89cgaDounC-srdogv3Ix8pd-J3EQiDG9nlYG90NG3I9z8';

export const firebaseConfig = {
  apiKey: 'AIzaSyCg8a00685ERCJUzVRbXN2zcB7obb0hphw',
  authDomain: 'cook-rb-life.firebaseapp.com',
  projectId: 'cook-rb-life',
  storageBucket: 'cook-rb-life.appspot.com',
  messagingSenderId: '469170802874',
  appId: '1:469170802874:web:a98c15362d3631ab233283',
};
